module.exports = __webpack_public_path__ + "files/0b944111e635d1d119fd2648a2fe0d75.png";